<template>
  <md-dialog v-bind="$attrs" v-on="$listeners" :md-fullscreen="false">
    <md-dialog-title v-if="mdTitle">{{ mdTitle }}</md-dialog-title>
    <md-dialog-content v-if="mdContent" v-html="mdContent"/>

    <md-dialog-actions>
      <md-button :class="cancelButtonClass" @click="onCancel">{{ mdCancelText }}</md-button>
      <md-button :class="'md-primary ' + confirmButtonClass" @click="onConfirm">{{ mdConfirmText }}</md-button>
    </md-dialog-actions>
    <loading-spinner-overlay v-if="sending"></loading-spinner-overlay>
  </md-dialog>
</template>

<script>
  import LoadingSpinnerOverlay from "./LoadingSpinnerOverlay";

  export default {
    name      : 'DeleteModal',
    components: {LoadingSpinnerOverlay},
    props     : {
      mdTitle           : String,
      mdContent         : String,
      mdConfirmText     : {
        type   : String,
        default: '削除'
      },
      mdCancelText      : {
        type   : String,
        default: 'キャンセル'
      },
      confirmButtonClass: {
        type   : String,
        default: null,
      },
      cancelButtonClass : {
        type   : String,
        default: null,
      },
      sending           : {
        type    : Boolean,
        required: false,
        default : false,
      },
    },
    methods   : {
      onCancel() {
        this.$emit('md-cancel');
        this.$emit('update:mdActive', false)
      },
      onConfirm() {
        this.$emit('md-confirm');
      }
    }
  }
</script>
